// InputUtil.js

import { InputType } from "./AppConst";
import ValueMisc from "./ValueMisc";
import IsValid from "./IsValid";

export default class InputUtil {

    static nullToString(text) {
        if(text===undefined || text===null) return '';
        return text;
    }

    static nullToZero(number) {
        if(number===undefined || number===null) return 0;
        return number;
    }

    static nullToDefault(value, defaultValue) {
        if(value===undefined || value===null) return defaultValue;
        return value;
    }

    static getFieldsToSubmit(inputMap, isEdit) {
        return Object.values(inputMap)
            .filter(dic=>isEdit ? dic.toEdit : dic.toAdd)
            .map(dic=>dic.id)
            .filter(id=>id); // To avoid undefined id
    }

    static getDataToSubmit(data, inputMap, isEdit) {
        let newData = {};
        for(const field of InputUtil.getFieldsToSubmit(inputMap, isEdit)) {
            let value = data[field];
            if(value === '') value = null;
            if(inputMap[field].type === InputType.number) {
                if(value==='-' || value==='' || value===null || value==='+') value = null;
                else if(typeof value === 'string') value = Number(value);
            }
            newData[field] = value; // data[field];
        }
        return newData;
    }

    // 새로운 입력내용을 기존 데이터에 반영하기 위해 사용
    static reflectData(inputSet, id, value, error, inputMap, isEdit) {
        let newInput = {data:{...inputSet.data}, error:{...inputSet.error}};
        newInput.data[id] = value;
        newInput.error[id] = error;
        newInput.changed = true;

        let hasError = error ? true : false; //Object.values(newInput.error).some((e)=>e);;

        // Check if there is any error
        for(const inputId of Object.keys(inputMap)) {
            if(newInput.error[inputId]) {
                hasError = true;
                break;
            }
            else {
                const map = inputMap[inputId];
                const isToSend = isEdit ? map.toEdit : map.toAdd;
                if(isToSend && map.required
                    && (
                        !newInput.data.hasOwnProperty(inputId)
                        || newInput.data[inputId] === null
                        || newInput.data[inputId] === ''
                    )
                ) {
                    newInput.error[inputId] = true;
                    hasError = true;
                    break;
                }
            }
        }
        newInput.hasError = hasError;
        const mapBad = {};
        // Find error fields and add to errorLabels
        for(const fieldId of Object.keys(inputMap)) {
            const needInput = isEdit ? inputMap[fieldId].toEdit : inputMap[fieldId].toAdd;

            if(newInput.error[fieldId]) {
                mapBad[fieldId] = true;
            }
            else if(needInput) {
                if(inputMap[fieldId].required && IsValid.nullString(newInput.data[fieldId])) {
                    mapBad[fieldId] = true;
                }
                else if(inputMap[fieldId].check) {
                    const check = inputMap[fieldId].check;
                    const good = check(newInput.data[fieldId]);
                    if(!good) {
                        mapBad[fieldId] = true;
                    }
                }
            }
        }
        newInput.errorLabels = Object.keys(mapBad).map(id=>inputMap[id].label);

        return newInput;
    }

    // *Dict.js file에 정의된 입력양식 상수 중 기초 데이터(default)만 추출.
    static defaultValuesFromInputMap(inputMap) {
        const defMap = {};
        for(const key of Object.keys(inputMap)) {
            const dict = inputMap[key];
            if(dict.toAdd && Boolean(dict.label)) {
                let defVal;
                if(inputMap[key].hasOwnProperty('default')) defVal = dict.default;
                else {
                    const type = dict.type;
                    const required = dict.required;
                    const toAdd = dict.toAdd;
                    if((type===InputType.number || type===InputType.int) && required && toAdd) defVal = 0;
                    else if(type===InputType.date && required && toAdd) defVal = ValueMisc.getYMD();
                    else if(type===InputType.datetime && required && toAdd) defVal = ValueMisc.getYmdHms();
                    else if(type===InputType.time && required && toAdd) defVal = '0000';
                    else if(type===InputType.checkbox) defVal = inputMap[key].falseValue || false;
                    else defVal = '';
                }
                defMap[key] = defVal;
            }
        }
        return defMap;
    }
};